<input
    type="checkbox"
    [ngModel]="value"
    (click)="next()"
    [disabled]="disabled"
    [indeterminate]="value === null"
/>
